import { Reducer } from "redux";

import { ReferralPhysicianDetails } from "../models/PhysicianDetails";
import { ReferralPhysicianDetailsResponse } from "../models/api/Referral";
import { GetPhysicianDetailsDispatchTypes } from "../models/dispatchTypes/Referral";
import { GetPhysicianDetailsActionDispatchTypes } from "../constants/Referral";

export const defaultData: ReferralPhysicianDetails = {
  primaryPhysician: {
    referralId: 0,
    referralPhysicianDetailId: 0,
    physicianId: 0,
    physicianName: "",
    physicianNpiId: "",
    phoneExt: "",
    phoneNo: "",
    taxId: null,
    streetName1: "",
    streetName2: "",
    fax: "",
    county: "",
    city: "",
    physicianState: "",
    zipCode: "",
    physicianTypeId: 0,
    physicianAddress: "",
    fullNameCreated: "",
    latitude: null,
    longitude: null,
    physicianSameAsPrimary: false
  },
  orderingPhysician: {
    referralId: 0,
    referralPhysicianDetailId: 0,
    physicianId: 0,
    physicianName: "",
    physicianNpiId: "",
    phoneExt: "",
    phoneNo: "",
    taxId: "",
    streetName1: "",
    streetName2: "",
    fax: "",
    county: "",
    city: "",
    physicianState: "",
    zipCode: "",
    physicianTypeId: 0,
    physicianAddress: "",
    physicianSameAsPrimary: true,
    fullNameCreated: "",
    latitude: undefined,
    longitude: undefined
  }
};

const initialState: ReferralPhysicianDetailsResponse = {
  loading: false,
  response: defaultData,
  error: null,
};

const PhysicianDetailsReducer: Reducer<
  ReferralPhysicianDetailsResponse,
  GetPhysicianDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetPhysicianDetailsActionDispatchTypes.GET_PHYSICIAN_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PhysicianDetailsReducer;
